import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import {
  GroupInterface,
  GroupMemberInterface,
} from '../../../../interfaces/groups/group.interface';
import { GroupsService } from '../../../../services/groups/groups.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { GroupsDetailsComponent } from '../../modals/groups-details/groups-details.component';

const typeDictionary = {
  [GroupMemberInterface.Team]: 'Teams',
  [GroupMemberInterface.Company]: 'Companies',
  [GroupMemberInterface.Brand]: 'Brands',
  [GroupMemberInterface.EmailAddress]: 'Email Addresses',
  [GroupMemberInterface.ExistingUser]: 'Users',
};

export function getTypeName(type: GroupMemberInterface): string {
  return typeDictionary[type] || 'Unknown';
}
@Component({
  selector: 'app-marketing-campaigns-groups',
  templateUrl: './marketing-campaigns-groups.component.html',
  styleUrls: ['./marketing-campaigns-groups.component.scss'],
})
export class MarketingCampaignsGroupsComponent implements OnInit {
  columnNames = ['id', 'name', 'description', 'memberType', 'actionmenu'];
  tableDataSource = new MatTableDataSource<GroupInterface>();
  public getTypeName = getTypeName;

  constructor(
    private groupsService: GroupsService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.groupsService.getAll().then((groups) => {
      this.tableDataSource.data = groups;
    });
  }

  add(): void {
    const dialogRef = this.dialog.open(GroupsDetailsComponent, {});
    dialogRef.afterClosed().subscribe((result) => {
      if (result.save) {
        this.snackBar.open('Group created.', '', { duration: 1000 });
        this.load();
      }
    });
  }

  async edit(group: GroupInterface): Promise<void> {
    const dialogRef = this.dialog.open(GroupsDetailsComponent, { data: { group } });
    dialogRef.afterClosed().subscribe((result) => {
      this.load();
      this.spinnerService.hide();
    });
    return;
  }
}
